import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FdCreatePagePlaceholderService } from '../../form-designer/fd-create-page-placeholder/fd-create-page-placeholder.service';
import { take, takeUntil } from 'rxjs/operators';
import { MasterListTableService } from './master-list-table.service';
import { Subject, combineLatest, forkJoin } from 'rxjs';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CustomButtonActionService } from 'custom-button-action';
import moment, { now } from 'moment';
import { Store, select } from '@ngrx/store';
import { SetDataSourceCountryList, getDataSourceCountryList } from 'visa-store';
import { ReferenceLibraryService } from 'reference-library';
import { ConfirmationService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { ImagilityBaseResponse } from 'app-models';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DatePipe } from '@angular/common';
import { environment } from 'environment-configurations';
import { FileUploadLibraryService } from 'file-upload-library';
import * as utils from 'src/app/modules/utility/global-utils';
import { MatDialog } from '@angular/material/dialog';
import { FbRedirectPopupComponent } from '../fb-redirect-popup/fb-redirect-popup.component';

@Component({
  selector: 'app-master-list-table',
  templateUrl: './master-list-table.component.html',
  styleUrls: ['./master-list-table.component.scss']
})
export class MasterListTableComponent implements OnChanges, OnDestroy {
  @Input() formBuilderId: number;
  @Input() formBuilderInfo: any;
  filters: any[];
  defaultColumns: any[];
  allTableValue: any[];
  tableValue: any[];
  actionsInfo: any;
  btnNames: string[] = [];
  emptyMsgFlag = false;
  popupMessageFlag = false;
  isNumber(val): boolean { return typeof val === 'number'; }
  isHTMLTags(val: string): boolean {
    const pattern = /<\/?[a-z][\s\S]*>/i;
    return pattern.test(val);
  }
  @Output() actionTriggered = new EventEmitter<{
    id: number,
    isBeneficiaryProfileListing: boolean,
    beneficiaryId: number,
    redirectTo: number
  }>();
  companyId: number;
  @ViewChild('op') overlayPanel: OverlayPanel;
  @ViewChild('vb') vbOverlayPanel: OverlayPanel;
  isBeneficiaryProfileListing: boolean;
  redirectList: any[] = [];
  customList: any[] = [];
  itemsPerPage = 10;
  totalRecords: number;
  currentPage = 1;
  filterDTO: any[] = [];
  filterOptionsFilled: boolean;
  FILTER_TYPES = {
    DROPDOWN: 'DROPDOWN',
    TEXTBOX: 'TEXTBOX',
    NUMBER: 'NUMBER',
    CALENDAR: 'CALENDAR',
    // other filter types...
  };
  openAccordionIndex: number | null = null;
  isAccordion = false;
  accordions: any = [];
  isAccordionStatusColumnName: string;
  multiselectactionsflag = false;
  multiActionBtn: any;
  displayMessageAction: any;
  isLoading: boolean = true;
  selectedRowsData: any[] = [];
  @Output() actionButtonClick: EventEmitter<string> = new EventEmitter<string>();
  observableSubscription$ = new Subject();
  backRedirectActionflag = false;
  backRedirectPageFormId: any;
  permissions: any[] = [];
  fbRoleId: number;
  isFilter: boolean;
  isClear: boolean;
  hasVisibleActions: boolean = false;
  multiActionBtns: any;
  currentYear: string;
  isFBUser: boolean;
  viewBy: string = '';
  viewByWeeklyStartDates = [];
  viewByWeeklyEndDates = [];
  disabledWeeklyStartDates = [];
  disabledWeeklyEndDates = [];
  minWeekStart;
  maxWeekStart;
  viewByObj = {
    weekStart: '',
    weekEnd: '',
    month: '',
    year: ''
  }
  viewByOptions: any = [];
  dateFilter = [{
    type: 'datepicker',
    from: '',
    to: '',
    label: `Select`,
    month: 0,
    year: null,
    selected: false
  }];
  selectedDateFilter: any;
  @ViewChild('dateFilterDropDown') dateFilterDropDown;
  constructor(
    private fdCreatePagePlaceholderService: FdCreatePagePlaceholderService,
    private masterListTableService: MasterListTableService,
    private customButtonActionService: CustomButtonActionService,
    private store: Store<any>,
    private referenceLibraryService: ReferenceLibraryService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private authenticationService: AuthenticationService,
    private datePipe: DatePipe,
    public uploadService: FileUploadLibraryService,
    private dialog: MatDialog
  ) {
    const keysToRemove = ['formDataId', 'FbEmployeeId', 'FbActualEmployeeId', 'idToGetDetails', 'pageFormId', 'AttendanceDataId', 'fbEditFormDataDTO', 'applicantId', 'applicantInfoId', 'redirectTabIndex'];
    keysToRemove.forEach(key => {
      if (key in sessionStorage) {
        sessionStorage.removeItem(key);
      }
    });
    this.companyId = 'companyId' in sessionStorage ?
      parseInt(sessionStorage.getItem('companyId')) : null;
    this.filters = [];
    this.viewBy = "";
    this.defaultColumns = [];
    this.tableValue = [];
    this.filterOptionsFilled = false;
    this.currentYear = this.datePipe.transform(new Date(), 'yyyy');
    this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    sessionStorage.setItem('isErrorEdit', String(false));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.formBuilderId && this.formBuilderInfo) {
      this.fbRoleId = 'fbRoleId' in sessionStorage ? Number(sessionStorage.getItem('fbRoleId')) : null;
      this.getOnloadDetails();
    }
  }

  getOnloadDetails() {
    this.isLoading = true;
    combineLatest([
      this.fdCreatePagePlaceholderService.getCustomHeaders(this.formBuilderId),
      this.fdCreatePagePlaceholderService.getBeneCustomHeaders(this.formBuilderId),
      this.authenticationService.currentUser
    ])
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.permissions = response[2]?.['permissions']?.length ? response[2].permissions : [];
        if (response[1]?.defaultColummns?.length > 0) {
          this.isBeneficiaryProfileListing = true;
          const masterListData = JSON.parse(JSON.stringify(response[1]));
          const actionsJson = masterListData.actionsJson ? JSON.parse(masterListData.actionsJson) : null;
          if (masterListData.filters?.length > 0) {
            this.filters = (actionsJson && actionsJson.filters ?
              actionsJson.filters :
              masterListData.filters)
              .filter(filter => [this.FILTER_TYPES.TEXTBOX, this.FILTER_TYPES.NUMBER, this.FILTER_TYPES.DROPDOWN, this.FILTER_TYPES.CALENDAR].includes(filter.typeOfFilter))
              .map(filter => {
                switch (filter.typeOfFilter) {
                  case this.FILTER_TYPES.TEXTBOX:
                    return {
                      ...filter,
                      uniqueName: filter.placeHolderDisplayName,
                      displayName: filter.placeHolderDisplayName,
                      value: null
                    };
                  case this.FILTER_TYPES.NUMBER:
                    return {
                      ...filter,
                      uniqueName: filter.placeHolderDisplayName,
                      displayName: filter.placeHolderDisplayName,
                      value: null
                    };
                  case this.FILTER_TYPES.DROPDOWN:
                    return {
                      ...filter,
                      uniqueName: filter.placeHolderDisplayName,
                      displayName: filter.placeHolderDisplayName,
                      options: [],
                      value: null
                    };
                  case this.FILTER_TYPES.CALENDAR:
                    return {
                      ...filter,
                      uniqueName: filter.placeHolderDisplayName,
                      displayName: filter.placeHolderDisplayName,
                      value: null
                    };
                }
              });
          }
          const columnPermissionsMap = new Map(actionsJson?.columnPermissions?.map(perm => [perm.uniqueName, perm]));
          this.defaultColumns = masterListData.defaultColummns
            .filter(column => {
              const permission: any = columnPermissionsMap.get(column.rptGroupPlaceHolderId);
              return !permission || Array.isArray(permission.selectedRoles) && permission.selectedRoles.includes(this.fbRoleId);
            })
            .map(column => ({
              ...column,
              displayName: column.placeHolderDisplayName
            }));
          this.setActionItems(masterListData);
          this.isAccordion = masterListData.isAccordion || false;
          this.multiselectactionsflag = masterListData.multiselectactionsflag || false;
          this.backRedirectActionflag = masterListData.backRedirectActionflag || false;
          this.emptyMsgFlag =  masterListData?.emptyMsgFlag || false;
          this.popupMessageFlag =  masterListData?.popupMessageFlag || false;
          this.btnNames = masterListData.btnNames;
          this.multiActionBtn = JSON.parse(masterListData.onMultiAction);
          if (masterListData?.displayMessageAction) {
          this.displayMessageAction = JSON.parse(masterListData.displayMessageAction);
          } else {
            this.displayMessageAction = null;
          }
          const backRedirectObj = JSON.parse(masterListData.onBackAction);
          this.backRedirectPageFormId = backRedirectObj?.pageFormId;
          this.setMultiActionItems(masterListData);

          this.viewBy = masterListData.viewBy;
          if (this.viewBy === 'weekly') {
            this.loadWeekStartAndEndDates();
          } else if (this.viewBy === 'monthly') {
            this.loadMonths();
          }
          this.getMasterListTableDataForBeneficiaryProfile();
        } else if (response[0]?.defaultColumns) {
          this.isBeneficiaryProfileListing = false;
          const masterListData = JSON.parse(response[0].defaultColumns);
          if (masterListData.filters?.length > 0) {
            this.filters = masterListData.filters
              .filter(filter => [this.FILTER_TYPES.TEXTBOX, this.FILTER_TYPES.NUMBER, this.FILTER_TYPES.DROPDOWN, this.FILTER_TYPES.CALENDAR].includes(filter.typeOfFilter))
              .map(filter => {
                switch (filter.typeOfFilter) {
                  case this.FILTER_TYPES.TEXTBOX:
                    return {
                      ...filter,
                      value: null
                    };
                  case this.FILTER_TYPES.NUMBER:
                    return {
                      ...filter,
                      value: null
                    };
                  case this.FILTER_TYPES.DROPDOWN:
                    return {
                      ...filter,
                      options: [],
                      value: null
                    };
                  case this.FILTER_TYPES.CALENDAR:
                    return {
                      ...filter,
                      value: null
                    };
                }
              });
          }
          this.setActionItems(masterListData);
          this.viewBy = masterListData.viewBy;
          if (this.viewBy === 'weekly') {
            this.loadWeekStartAndEndDates();
          } else if (this.viewBy === 'monthly') {
            this.loadMonths();
          }
          if (masterListData.defaultColumns?.length > 0) {
            this.defaultColumns = masterListData.defaultColumns;
            this.getMasterListTableData();
          }
        }
      });
  }

  setMultiActionItems(masterListData: any) {
    const actionsJson = masterListData.onMultiAction ? JSON.parse(masterListData.onMultiAction) : null;
    if (actionsJson) {
      this.multiActionBtns = actionsJson.actions.map(action => {
        const selectedRoles = action.selectedRoles || [];
        const isVisible = !action.isPermissionAdded || selectedRoles.includes(this.fbRoleId);
        return {
          ...action,
          isVisible: isVisible
        };
      });
      this.hasVisibleActions = this.multiActionBtns.some(action => action.isVisible);
    } else {
      this.hasVisibleActions = false;
    }
  }

  loadWeekStartAndEndDates() {
    let currentDate = new Date();
    let currentDay = currentDate.getDate();
    let currentMonth = currentDate.getMonth();
    let currentYear = currentDate.getFullYear();
    let prevYear = currentDate.getFullYear() - 1;

    this.minWeekStart = new Date(prevYear, currentMonth, currentDay);
    this.maxWeekStart = new Date(currentYear, currentMonth, currentDay);
    //for loop for 4 weeks 
    for (let i = 1; i <= 4; i++) {
      //let date = new Date().getDate() + i*7;
      let prevMonday = utils.getPreviousMonday(new Date(), i * 7);
      let prevSunday = utils.getPreviousSunday(new Date(), (i - 1) * 7);
      this.dateFilter.push({
        type: 'text',
        from: moment(prevMonday).format('YYYY-MM-DD'),
        to: moment(prevSunday).format('YYYY-MM-DD'),
        label: `View By - ${moment(prevMonday).format('MM/DD/YYYY')} to ${moment(prevSunday).format('MM/DD/YYYY')}`,
        month: null,
        year: null,
        selected: (i === 1) ? true : false
      });
      if (i === 1) {
        this.selectedDateFilter = {
          type: 'text',
          from: moment(prevMonday).format('YYYY-MM-DD'),
          to: moment(prevSunday).format('YYYY-MM-DD'),
          label: `View By - ${moment(prevMonday).format('MM/DD/YYYY')} to ${moment(prevSunday).format('MM/DD/YYYY')}`,
          month: null,
          year: null,
          selected: true
        };
      }
    }
  }

  loadMonths() {
    let date = new Date();
    let year = date.getFullYear();
    let monthVar = date.getMonth();

    for (let i = 0; i <= 12; i++) {
      if (monthVar < 0) {
        monthVar = 11;
        year--;
      }
      let month = moment(monthVar + 1, 'MM').format('MMMM')
      this.dateFilter.push({
        type: 'text',
        from: '',
        to: '',
        label: `View By - ${month}, ${year}`,
        month: monthVar + 1,
        year: year,
        selected: (i === 0) ? true : false
      });
      if (i === 0) {
        this.selectedDateFilter = {
          type: 'text',
          from: '',
          to: '',
          label: `View By - ${month}, ${year}`,
          month: monthVar + 1,
          year: year,
          selected: true
        };
      }
      monthVar--;
    }
  }
  onClickDropdownItem(e, item) {
    if (item.type === 'datepicker') {
      e.stopPropagation();
    }
    item.selected = true;
    this.dateFilter.filter(x => x.label !== item.label && x.selected).forEach(x => {
      x.selected = false;
    });
    this.selectedDateFilter = item;
    this.viewByObj = {
      weekStart: (item.from) ? moment(item.from).format('YYYY-MM-DD') : '',
      weekEnd: (item.to) ? moment(item.to).format('YYYY-MM-DD') : '',
      month: (item.month) ? item.month : null,
      year: (item.year) ? item.year : null,
    }

  }
  onSelectDate(e, item) {
    this.selectedDateFilter = {
      type: 'text',
      from: item.from,
      to: item.to,
      label: `View By - ${moment(item.from).format('MM/DD/YYYY')} to ${moment(item.to).format('MM/DD/YYYY')}`,
      month: '',
      year: '',
      selected: true
    };
    this.dateFilter.filter(x => x.label !== item.label && x.selected).forEach(x => {
      x.selected = false;
    });
    this.viewByObj = {
      weekStart: (item.from) ? moment(item.from).format('YYYY-MM-DD') : '',
      weekEnd: (item.to) ? moment(item.to).format('YYYY-MM-DD') : '',
      month: (item.month) ? item.month : null,
      year: (item.year) ? item.year : null,
    }
  }
  clearViewByTo(e, item) {
    console.log(item);
    item.to = '';
    console.log(item);
  }
  setActionItems(masterListData: any) {
    const actionsJson = this.isBeneficiaryProfileListing ? JSON.parse(masterListData.actionsJson) : masterListData.actionsJson;
    if (masterListData.actionsflag && actionsJson?.actions) {
      if (actionsJson.actions?.edit && actionsJson.editJsonAction?.isPermissionAdded) {
        if (Array.isArray(actionsJson.editJsonAction.selectedRoles)) {
          actionsJson.actions.edit = actionsJson.editJsonAction.selectedRoles.includes(this.fbRoleId);
        } else {
          actionsJson.actions.edit = false;
        }
      }
      if (actionsJson.actions?.redirect && actionsJson.redirectActions?.length > 0) {
        this.redirectList = actionsJson.redirectActions.filter(x => !x.isPermissionAdded || (Array.isArray(x.selectedRoles) && x.selectedRoles.includes(this.fbRoleId)));
        actionsJson.actions.redirect = !!(this.redirectList?.length > 0)
      }
      if (actionsJson.actions?.custom && actionsJson.customActions?.length > 0) {
        this.customList = actionsJson.customActions.filter(x => !x.isPermissionAdded || (x.isPermissionAdded && x.permissionName && this.permissions.includes(x.permissionName)));
        actionsJson.actions.custom = !!(this.customList?.length > 0)
      }
      if (actionsJson.actions?.profile && actionsJson.profileJsonAction?.isPermissionAdded) {
        if (actionsJson.profileJsonAction.permissionName) {
          actionsJson.actions.profile = this.permissions.includes(actionsJson.profileJsonAction.permissionName);
        } else {
          actionsJson.actions.profile = false;
        }
      }
      if (actionsJson.actions?.Delete && actionsJson.DeleteJsonAction?.isPermissionAdded) {
        if (actionsJson.DeleteJsonAction.permissionName) {
          actionsJson.actions.Delete = this.permissions.includes(actionsJson.DeleteJsonAction.permissionName);
        } else {
          actionsJson.actions.Delete = false;
        }
      }
      const allFalse = Object.values(actionsJson.actions).every(value => value === false);
      this.actionsInfo = {
        actionsflag: !allFalse,
        actions: actionsJson.actions,
        editJsonAction: actionsJson.editJsonAction ? actionsJson.editJsonAction : null,
        profileJsonAction: actionsJson.profileJsonAction ? actionsJson.profileJsonAction : null,
        DeleteJsonAction: actionsJson.DeleteJsonAction ? actionsJson.DeleteJsonAction : null,

      };
    }
  }

  editShowCheck(rowData: any): boolean {
    if (!(this.actionsInfo && this.actionsInfo.actions && this.actionsInfo.editJsonAction && this.actionsInfo.actions.edit)) {
      return false;
    }
    const editJsonAction = this.actionsInfo.editJsonAction;
    return this.showCheck(rowData, editJsonAction);
  }

  editProfileCheck(rowData: any): boolean {
    if (!(this.actionsInfo && this.actionsInfo.actions && this.actionsInfo.profileJsonAction && this.actionsInfo.actions.profile)) {
      return false;
    }
    const profileJsonAction = this.actionsInfo.profileJsonAction;
    return this.showCheck(rowData, profileJsonAction);
  }

  deleteCheck(rowData: any): boolean {
    if (!(this.actionsInfo && this.actionsInfo.actions && this.actionsInfo.DeleteJsonAction && this.actionsInfo.actions.Delete)) {
      return false;
    }
    const DeleteJsonAction = this.actionsInfo.DeleteJsonAction;
    return this.showCheck(rowData, DeleteJsonAction);
  }

  showCheck(rowData: any, jsonAction: any): boolean {
    if (!jsonAction?.isBasedOnStatus && !jsonAction?.isHideOnStatus) {
      return true;
    }
    if (jsonAction?.isBasedOnStatus && rowData[jsonAction.statusColumn] && jsonAction.statusName?.length > 0 && jsonAction.statusName.some(x => x.toLowerCase() === rowData[jsonAction.statusColumn].toLowerCase())) {
      return true;
    }
    if (jsonAction?.isHideOnStatus && rowData[jsonAction.hideStatusColumn] && jsonAction.hideStatusName?.length > 0 && !jsonAction.hideStatusName.some(x => x.toLowerCase() === rowData[jsonAction.hideStatusColumn].toLowerCase())) {
      return true;
    }
    return false;
  }

  private setOrRemoveSessionStorageItem(key: string, value: any) {
    if (value !== null && value !== undefined) {
      sessionStorage.setItem(key, value);
    } else if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }

  handleRedirect(redirectItem: any, rowData: any) {

    if (redirectItem?.isPopUpRequired === true && rowData?.apiRowData?.interviewProcessSetupId === 0) {
      this.openPopup();
    }
    else {
      this.setOrRemoveSessionStorageItem('currentPageFormId', rowData.pageFormId || this.formBuilderId);
      this.setOrRemoveSessionStorageItem('formDataId', rowData.formDataId);  //basic details component issue fix
      if (redirectItem.pageFormId) {
        this.customButtonActionService.getPageFormById(redirectItem.pageFormId)
          .pipe(take(1))
          .subscribe((response: any) => {
            if (response) {
              const item = {
                formType: response.buildFormatTypeId,
                pageFormId: response.id
              }
              if (this.isBeneficiaryProfileListing) {
                sessionStorage.setItem('buildFormatTypeId', response.buildFormatTypeId);
                if ('fbFormDataDTO' in sessionStorage) {
                  const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
                  // if (response.buildFormatTypeId === 1483) {
                  fbFormDataDTO.push(rowData.apiRowData);
                  // }

                  sessionStorage.setItem('fbFormDataDTO', JSON.stringify(fbFormDataDTO));
                } else {
                  sessionStorage.setItem('fbFormDataDTO', JSON.stringify([rowData.apiRowData]));
                  this.setOrRemoveSessionStorageItem('redirectPageFormId', redirectItem.pageFormId);
                }
                this.setOrRemoveSessionStorageItem('redirectTabIndex', redirectItem.tabIndex)
                this.setOrRemoveSessionStorageItem('interviewProcessSetupId', rowData.apiRowData.interviewProcessSetupId);
                this.setOrRemoveSessionStorageItem('FbEmployeeId', rowData.fb_beneficiaryId);
                this.setOrRemoveSessionStorageItem('FbActualEmployeeId', rowData.fb_employeeId);
                this.setOrRemoveSessionStorageItem('AttendanceDataId', rowData.fb_id);
                this.setOrRemoveSessionStorageItem('idToGetDetails', rowData.fb_id);
                this.setOrRemoveSessionStorageItem('applicantId', rowData.applicantId);
                this.setOrRemoveSessionStorageItem('applicantInfoId', rowData.applicantClientJobPositionsId);
                if (sessionStorage.getItem('formName') == "Job Openings") {
                  sessionStorage.setItem('selectedjobposition', sessionStorage.getItem('AttendanceDataId'));
                  sessionStorage.setItem('selectedjobpositionfbFormDataDTO', sessionStorage.getItem('fbFormDataDTO'));
                }
                if (rowData.leaveRequestId) {
                  this.setOrRemoveSessionStorageItem('leaveRequestId', rowData.leaveRequestId);
                }
              } else {
                this.setOrRemoveSessionStorageItem('formDataId', rowData.id);
              }
              sessionStorage.setItem('columnKeyValuePair', JSON.stringify(rowData.postedData));
              this.customButtonActionService.onLinkRedirectPageSubject.next(item);
            }
          });
      }
    }
  }

  onPageChange(event: any) {
    // event.first: Index of the first record displayed
    // event.rows: Number of rows per page
    // You can use these values to make an API call with pagination
    this.isFilter = false;
    this.isClear = false;
    this.currentPage = event.first / event.rows + 1;
    this.itemsPerPage = event.rows;
    this.loadMasterList();
  }

  onPageSizeChange(event: any) {
    // event.rows: Number of rows per page
    // You can use this value to make an API call with the new page size
    this.itemsPerPage = event.rows;
    this.loadMasterList();
  }

  getLatestRowID() {
    const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[] || [];
    return fbFormDataDTO.length ? fbFormDataDTO[fbFormDataDTO.length - 1] : null;
  }

  getMasterListTableDataForBeneficiaryProfile() {
    const fbFormDataDTO = 'fbFormDataDTO' in sessionStorage ? this.getLatestRowID() : null;
    const payload = {
      pageNumber: this.isAccordion || this.isFilter ? 0 : this.currentPage,
      recordsPerPage: this.isAccordion ? 0 : this.itemsPerPage,
      filterDTOList: this.filterDTO,
      fbFormDataDTO,
      viewBy: this.viewByObj
    };
    this.masterListTableService.getBeneProfileMasterListData(
      this.formBuilderInfo.moduleId,
      this.formBuilderId,
      this.companyId,
      payload
    ).pipe(take(1))
      .subscribe((response: any) => {
        if (!response?.elements || response.elements.length === 0) {
          this.tableValue = [];
          this.isLoading = false;
          this.accordions = [];
          this.fillFilterValues();
          return;
        }
        this.tableValue = response.elements.map((x, i) => {
          let returnObj: any = {};
          let postedData: any = {};

          returnObj[`apiRowData`] = x;
          Object.keys(x).forEach((key: any) => {
            if (!isNaN(key.trim())) {
              const columneObj = this.defaultColumns.find(y => y.rptGroupPlaceHolderId === Number(key.trim()));
              if (columneObj) {
                returnObj[columneObj.displayName] = x[key] != '[]' ? x[key] : '--';
                postedData[columneObj.displayName] = x[key] != '[]' ? x[key] : '--';
              }
            }
            returnObj[`postedData`] = postedData;
            if (key.trim() === 'id') {
              returnObj['fb_id'] = x[key];
            }
            if (key.trim() === 'formDataId') {
              returnObj['formDataId'] = x[key];
            }
            if (key.trim() === 'leaveRequestId') {
              returnObj['leaveRequestId'] = x[key];
            }
            if (key.trim() === 'beneficiaryId') {
              returnObj['fb_beneficiaryId'] = x[key];
            }
            if (key.trim() === 'employeeId') {
              returnObj['fb_employeeId'] = x[key];
            }
            if (key.trim() === 'pageFormId') {
              returnObj['pageFormId'] = x[key];
            }
            if (key.trim() === 'accordionId') {
              returnObj['accordionId'] = x[key];
            }
            if (key.trim() === 'accordionName') {
              returnObj['accordionName'] = x[key];
            }
            if (key.trim() === 'uniqueName') {
              returnObj[`uniqueName`] = x[key];
            }
            if (key.trim() === 'applicantId') {
              returnObj['applicantId'] = x[key];
            }
            if (key.trim() === 'applicantClientJobPositionsId') {
              returnObj['applicantClientJobPositionsId'] = x[key];
            }
            returnObj['showEditOption'] = this.editShowCheck(JSON.parse(JSON.stringify(returnObj)));
            returnObj['showProfileOption'] = this.editProfileCheck(JSON.parse(JSON.stringify(returnObj)));
            returnObj['showDeleteOption'] = this.deleteCheck(JSON.parse(JSON.stringify(returnObj)));
            returnObj['showRedirectOption'] = this.redirectList.map((x) => {
              return this.showCheck(JSON.parse(JSON.stringify(returnObj)), x);
            })
            returnObj['showCustomOption'] = this.customList.map((x) => {
              return this.showCheck(JSON.parse(JSON.stringify(returnObj)), x);
            })
          });
          if (i === 0 && this.isAccordion) {
            let statusKey = Object.keys(returnObj).find(key => key.toLowerCase() === 'status');
            if (!statusKey) {
              statusKey = Object.keys(returnObj).find(key => key.toLowerCase().includes('status'));
            }
            this.isAccordionStatusColumnName = statusKey || null;
          }
          return {
            ...returnObj
          };
        });
        if (this.isAccordion && this.tableValue?.length > 0) {
          // const uniqueStatuses = this.isAccordionStatusColumnName ?
          //   Array.from(new Set(this.tableValue.map(obj => obj[this.isAccordionStatusColumnName]))) : [];
          const uniqueStatuses = this.isAccordionStatusColumnName
            ? Array.from(
              new Set(
                this.tableValue
                  .filter((obj) => obj[this.isAccordionStatusColumnName] !== null)
                  .map((obj) => obj[this.isAccordionStatusColumnName])
              )
            )
            : [];

          const groupedEmployees = this.tableValue.reduce((acc, row) => {
            const { accordionId, accordionName } = row;
            if (!acc[accordionId]) {
             // const filteredTableValue = this.tableValue.filter(obj => obj.accordionId === accordionId);
             const filteredTableValue = this.tableValue.filter(
              (obj) => obj.accordionId === accordionId && obj[this.isAccordionStatusColumnName] !== null
            );
            
              acc[accordionId] = {
                code: accordionId,
                title: accordionName,
                statusLegendArray: uniqueStatuses.length > 0 ? [{
                  name: 'Total',
                  count: filteredTableValue.length
                }, ...uniqueStatuses.map(status => {
                  const statusTableValue = filteredTableValue.filter(obj => obj[this.isAccordionStatusColumnName] === status);
                  return {
                    name: status,
                    count: statusTableValue ? statusTableValue.length : 0
                  };
                })] : [{
                  name: 'Total',
                  count: 0
                }],
                openAccordion: false,
                tableValue: [],
              };
            }
            row[this.isAccordionStatusColumnName] ? acc[accordionId].tableValue.push(row) : [];
            return acc;
          }, {});

          this.accordions = Object.values(groupedEmployees);
        }
        this.totalRecords = response.totalCount;
        if (!this.isFilter) {
          this.currentPage = response.pageNumber;
        }
        this.itemsPerPage = response.recordsPerPage;
        this.fillFilterValues();
      });
  }

  getMasterListTableData() {
    const payload = {
      pageNumber: this.currentPage,
      recordsPerPage: this.itemsPerPage,
      filterDTOList: this.filterDTO,
      viewBy: this.viewByObj
    };
    this.masterListTableService.getMasterListData(
      this.formBuilderId,
      this.companyId,
      payload
    ).pipe(take(1))
      .subscribe((response: any) => {
        if (!response?.createdForms || response.createdForms.length === 0) {
          this.tableValue = [];
          this.isLoading = false;
          this.fillFilterValues();
          return;
        }
        this.tableValue = JSON.parse(JSON.stringify(response.createdForms));
        this.totalRecords = response.totalCount;
        if (!this.isFilter) {
          this.currentPage = response.pageNumber;
        }
        this.itemsPerPage = response.recordsPerPage;
        this.fillFilterValues();
      });
  }

  fillFilterValues() {
    if (this.filterOptionsFilled) {
      return;
    }
    this.filterOptionsFilled = true;

    if (!this.filters || this.filters.length === 0) {
      return;
    }

    const filterObservables = this.filters.map(async (filter) => {
      if (filter.typeOfFilter !== this.FILTER_TYPES.DROPDOWN ||
        (filter.typeOfFilter === this.FILTER_TYPES.DROPDOWN && !filter.apiToCall)) {
        return { ...filter };
      }

      if (filter.apiToCall.startsWith('/referenceLibrary/')) {
        filter.apiToCall = filter.apiToCall.substring('/referenceLibrary/'.length);
      }

      let options;

      try {
        if (filter.apiToCall === 'Country') {
          options = await this.getCountryDataSource();
        } else {
          options = await this.getDataSource(filter.apiToCall);
        }
      } catch (error) {
        return { ...filter }; // Return the original filter if there's an error
      }

      return options ? { ...filter, options } : { ...filter };
    });

    forkJoin(filterObservables).subscribe((updatedFilters) => {
      this.filters = updatedFilters;
    });
  }

  private async getCountryDataSource() {
    const data = await this.store.pipe(select(getDataSourceCountryList)).pipe(take(1)).toPromise();
    if (data && data.length > 0) {
      return data;
    }

    const response = await this.referenceLibraryService.getDataSource('COUNTRY', '').pipe(take(1)).toPromise();
    this.store.dispatch(new SetDataSourceCountryList(response || null));
    return response;
  }

  private async getDataSource(apiToCall: string) {
    return this.referenceLibraryService.getDataSource(apiToCall, '').pipe(take(1)).toPromise();
  }

  handleEdit(rowData: any) {
    if ('fbFormDataDTO' in sessionStorage) {
      sessionStorage.removeItem('fbFormDataDTO');
    }
    sessionStorage.setItem('fbEditFormDataDTO', JSON.stringify(rowData.apiRowData));
    sessionStorage.setItem('pageFormId', rowData.pageFormId || null);
    sessionStorage.setItem('formDataId', rowData.formDataId || null);
    sessionStorage.setItem('columnKeyValuePair', JSON.stringify(rowData.postedData));
    this.actionTriggered.emit({
      id: this.isBeneficiaryProfileListing ?
        (this.actionsInfo?.editJsonAction?.selectedEditOption &&
          this.actionsInfo?.editJsonAction?.selectedEditOption === 'BF' ?
          rowData.formDataId : rowData.fb_id) :
        rowData.id,
      isBeneficiaryProfileListing: this.isBeneficiaryProfileListing,
      beneficiaryId: rowData.fb_beneficiaryId && this.isBeneficiaryProfileListing ? rowData.fb_beneficiaryId : null,
      redirectTo: this.actionsInfo?.editJsonAction?.selectedEditOption && this.actionsInfo?.editJsonAction?.selectedEditOption === 'BF' ? this.actionsInfo?.editJsonAction?.selectedButtonPageFormId : 0
    });
  }

  handleEditProfile(rowData: any) {
    if ('fbFormDataDTO' in sessionStorage) {
      sessionStorage.removeItem('fbFormDataDTO');
    }
    sessionStorage.setItem('fbEditFormDataDTO', JSON.stringify(rowData.apiRowData));
    sessionStorage.setItem('pageFormId', rowData.pageFormId || null);
    sessionStorage.setItem('formDataId', rowData.formDataId || null);
    this.actionTriggered.emit({
      id: this.isBeneficiaryProfileListing ?
        (this.actionsInfo?.profileJsonAction?.selectedEditOption &&
          this.actionsInfo?.profileJsonAction?.selectedEditOption === 'BF' ?
          rowData.formDataId : rowData.fb_id) :
        rowData.id,
      isBeneficiaryProfileListing: this.isBeneficiaryProfileListing,
      beneficiaryId: rowData.fb_beneficiaryId && this.isBeneficiaryProfileListing ? rowData.fb_beneficiaryId : null,
      redirectTo: this.actionsInfo?.profileJsonAction?.selectedEditOption && this.actionsInfo?.profileJsonAction?.selectedEditOption === 'BF' ? this.actionsInfo?.profileJsonAction?.selectedButtonPageFormId : 0
    });
  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    this.tableValue.forEach(row => row.selected = isChecked);
    if (isChecked) {
      this.selectedRowsData = this.tableValue.filter(row => row.selected);
    } else {
      this.selectedRowsData = [];
    }
  }

  isAllSelected() {
    if (this.tableValue.length === 0) {
      return false;
    }
    return this.tableValue.every(row => row.selected);
  }

  onCheckboxChange(rowData: any) {
    if (rowData.selected) {
      this.selectedRowsData.push(rowData);
    } else {
      this.selectedRowsData = this.selectedRowsData.filter(row => row !== rowData);
    }
  }
  download(file) {
    const baseUrl = environment.docs.replace('docs/', 'docs');
    if (file.Resume) {
      this.uploadService.downloadDocuments(
        baseUrl + file?.Resume?.replace('/var/imagility/uploads', ''),
        this.isFBUser ? file.Resume?.split('/').slice(-1)[0] : file.Resume?.substring(9)
      );
    } else if (file.Documents) {
      const baseAppUrl = environment.appUrl;
      this.uploadService.downloadDocuments(
        baseAppUrl + file?.Documents?.replace('var/www/', ''),
        this.isFBUser ? file.Documents?.split('/').slice(-1)[0] : file.Documents?.substring(9)
      );
    }
  }
  postMultiAction(actionName) {
    const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
    const profileMatchDTO = this.selectedRowsData.map(row => ({
      selectedMlId: row['fb_id'],
      profileMatchScore: row['Profile Match'] !== null ? `${row['Profile Match']}` : null
    }));

    const payload = {
      selectedMlIds: this.selectedRowsData.map(row => row['fb_id']),
      actionName: actionName,
      jobPostPositionId: fbFormDataDTO ? fbFormDataDTO[fbFormDataDTO.length - 1].jobPostPositionId : null,
      profileMatchDTO: profileMatchDTO
    };
    this.masterListTableService.moveSelectedListItems(payload).pipe(take(1))
      .subscribe((response: any) => {
        this.actionButtonClick.emit(actionName);
        if (sessionStorage.getItem('formName') !== "Job Openings") {
        this.toastr.success(response.message, 'Success');
        }
      });
  }

  handleMultiAction(actionName: string) {
    const selectedAction = this.multiActionBtn.actions.find(action => action.btnName.toLowerCase() === actionName.toLowerCase());
    this.customButtonActionService.setActionName(actionName);
    if (selectedAction && selectedAction.pageFormId === null) {
      this.postMultiAction(actionName)
    } else {
      if (selectedAction) {
        this.postMultiAction(actionName);
        this.handleBtnActionRedirect(selectedAction.pageFormId);
      }
    }
  }
  openPopup(){
    const dialogRef = this.dialog.open(FbRedirectPopupComponent, {
      width: '500px',
      data: {
        displayMessageAction: this.displayMessageAction
      }
    });

    const instance = dialogRef.componentInstance;
    instance.confirmAction.subscribe((redirectBtnName: string) => {
      this.handleEmptyRedirectAction(redirectBtnName); 
      dialogRef.close();
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('User confirmed');
      } else {
        console.log('User cancelled');
      }
    });
  }
  handleEmptyRedirectAction(actionName: string) {
    const selectedAction = this.displayMessageAction.actions.find(action => action.redirectBtnName.toLowerCase() === actionName.toLowerCase());
    this.customButtonActionService.setActionName(actionName);
    if (selectedAction) {
      this.handleBtnActionRedirect(selectedAction.pageFormId);
    }
  }
  handleBtnActionRedirect(pageFormId: number) {
    this.customButtonActionService.getPageFormById(pageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          const ids = this.selectedRowsData.map(row => row['fb_id']);
          this.setOrRemoveSessionStorageItem('selectedRowIds', JSON.stringify(ids));
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          sessionStorage.setItem('buildFormatTypeId', response.buildFormatTypeId);
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }


  goBack(pageFormId: number) {
    this.customButtonActionService.getPageFormById(pageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          const ids = this.selectedRowsData.map(row => row['fb_id']);
          this.setOrRemoveSessionStorageItem('selectedRowIds', JSON.stringify(ids));
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          sessionStorage.setItem('buildFormatTypeId', response.buildFormatTypeId);
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }

  handleCalendarFilter(filter) {
    const baseCalendarObj = {
      fromDate: null,
      toDate: null
    };

    switch (filter.filterCalenderType) {
      case 'DW':
        baseCalendarObj.fromDate = filter.value ? moment(filter.value).format('YYYY-MM-DD') : null;
        baseCalendarObj.toDate = filter.value ? moment(filter.value).format('YYYY-MM-DD') : null;
        break;
      case 'RS':
        baseCalendarObj.fromDate = filter.value ? moment(filter.value).format('YYYY-MM-DD') : null;
        break;
      case 'RE':
        baseCalendarObj.toDate = filter.value ? moment(filter.value).format('YYYY-MM-DD') : null;
        break;
      // other calendar types...
    }

    return baseCalendarObj;
  }

  createFilterObject(filter) {
    const baseObj = {
      rptGroupPlaceHolderId: filter.rptGroupPlaceHolderId,
      placeHolderDisplayName: filter.placeHolderDisplayName,
      typeOfFilter: filter.typeOfFilter,
      filterUITypeId: filter.filterUITypeId,
      id: filter.rptGroupPlaceHolderId,
      apiToCall: filter.apiToCall,
      strValue: null,
      intValue: null,
      fromDate: null,
      toDate: null
    };

    switch (filter.typeOfFilter) {
      case this.FILTER_TYPES.DROPDOWN:
      case this.FILTER_TYPES.TEXTBOX:
        return { ...baseObj, strValue: filter.value };
      case this.FILTER_TYPES.NUMBER:
        return { ...baseObj, intValue: [filter.value] };
      case this.FILTER_TYPES.CALENDAR:
        return { ...baseObj, ...this.handleCalendarFilter(filter) };
      // other cases...
    }
  }

  onFilter() {
    this.filterDTO = this.filters.filter(filter => {
      if (filter.typeOfFilter == 'NUMBER') {
        return (filter.value || filter.value == 0)
      } else {
        return filter.value;
      }
    })
      .map(filter => this.createFilterObject(filter));
    if (!this.isClear) {
      this.isFilter = true
    }
    this.loadMasterList();

    if (this.overlayPanel) {
      this.overlayPanel.hide();
    }
  }

  loadMasterList() {
    if (this.isBeneficiaryProfileListing) {
      this.getMasterListTableDataForBeneficiaryProfile();
    } else {
      this.getMasterListTableData();
    }
  }

  // meetsFilterCriteria(item) {
  //   for (const filter of this.filters.filter(filter => filter.value)) {
  //     if (filter.typeOfFilter === "CALENDAR") {
  //       const formattedFilterValue = moment(filter.value).format("MM-DD-YYYY");
  //       const value = moment(item[filter.displayName]).format("MM-DD-YYYY");
  //       if (formattedFilterValue !== value) {
  //         return false;
  //       }
  //     } else {
  //       const value = item[filter.displayName];
  //       if ([this.FILTER_TYPES.TEXTBOX, this.FILTER_TYPES.DROPDOWN].includes(filter.typeOfFilter) &&
  //         !(value.toLowerCase().includes(filter.value.toLowerCase()) || filter.value.toLowerCase().includes(value.toLowerCase()))) {
  //         return false;
  //       }
  //     }
  //   }
  //   return true;
  // }

  onClear() {
    this.isClear = true;
    this.isFilter = false;
    this.filters = this.filters
      .map(x => {
        return {
          ...x,
          value: null
        };
      });
    this.onFilter();
  }

  handleDelete(rowData) {
    const payload =
    {
      "companyId": this.companyId,
      "formDataId": rowData?.formDataId ? rowData.formDataId : null,
      "listId": rowData?.fb_id ? rowData.fb_id : null,
      "pageFormId": rowData?.pageFormId ? rowData.pageFormId : null,
      "uniqueName": rowData?.uniqueName ? rowData.uniqueName : null,
    }

    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete',
      accept: () => {
        this.masterListTableService.deleteMasterListData(payload
        ).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
          if (response?.status === 200) {
            this.toastr.success(response.message, 'Success');
            this.loadMasterList();
          }
        });
      },
      reject: () => {
      }
    });
  }
  handleCustom(rowData, uniquekey) {
    const payload =
    {
      "companyId": this.companyId,
      "formDataId": rowData?.formDataId ? rowData.formDataId : null,
      "listId": rowData?.fb_id ? rowData.fb_id : null,
      "pageFormId": rowData?.pageFormId ? rowData.pageFormId : null,
      "uniqueName": rowData?.uniqueName ? rowData.uniqueName : null,
      "rowData": rowData?.apiRowData || null
    }
    this.confirmationService.confirm({
      message: 'Are you sure you want to perform this action?',
      header: 'Confirm',
      accept: () => {
        this.masterListTableService.postCustomAction(payload, uniquekey
        ).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
          if (response?.status === 200) {
            this.toastr.success(response.message, 'Success');
            this.loadMasterList();
          }
        });
      },
      reject: () => {
      }
    });
    console.log(payload, uniquekey);

  }
  onViewBy() {
    this.loadMasterList();
    if (this.vbOverlayPanel) {
      this.vbOverlayPanel.hide();
    }
  }
  onClearViewBy() {
    this.viewByObj = {
      weekStart: '',
      weekEnd: '',
      month: '',
      year: ''
    }
    this.dateFilter.forEach(x => {
      x.selected = false;
    });
    this.dateFilter[0].from = '';
    this.dateFilter[0].to = '';
    this.selectedDateFilter = this.dateFilter[1];
    this.dateFilter[1].selected = true;

    if (this.vbOverlayPanel) {
      this.vbOverlayPanel.hide();
    }
    this.loadMasterList();
  }
  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
